// app/frontend/components/Cards/RecentSupporterCard.tsx

import React from 'react';
import { Card, Group, Image, Text, Skeleton, Box, Stack } from '@mantine/core';
import artistStarIcon from '../../../assets/images/money-star-icon.png';
import { useMediaQuery } from '@mantine/hooks';

interface User {
  username: string;
}

interface StarPurchase {
  id: number;
  stars: number;
  message?: string;
  supporter_name?: string;
  user?: User | null;
}

interface RecentSupporterCardProps {
  purchase: StarPurchase;
}

const RecentSupporterCard: React.FC<RecentSupporterCardProps> = ({ purchase }) => {
  const username = purchase.user?.username ?? purchase.supporter_name ?? 'Anonymous Supporter';

  const isMobile = useMediaQuery('(max-width: 576px)');

  return (
    <Card
      key={purchase.id}
      shadow="sm"
      mx={isMobile ? '0px' : '12px'}
      padding={0}
      radius="md"
      style={{
        backgroundColor: '#17171750',
        borderColor: '#5c5c3c',
        overflow: 'hidden',
        display: 'flex', // make card a flex container
        flexDirection: 'column', // stack its children vertically
        justifyContent: 'center', // center them vertically
      }}
    >
      <Box style={{ padding: 12, width: '100%', display: 'flex', alignItems: 'center' }}>
        <Image src={artistStarIcon} className="star-icon" alt="Star Icon" width={28} />
        <Stack gap="0px" align="left" justify="flex-start">
          <Text fw={500} className="poppins" style={{ fontSize: 16, color: '#FF7F00' }}>
            {username} bought {purchase.stars} {purchase.stars === 1 ? 'star' : 'stars'}.
          </Text>
          {purchase.message && (
            <Box px={4}>
              <Text size="sm" className="poppins" style={{ color: '#f2f2f2', fontSize: 16 }}>
                “{purchase.message}”
              </Text>
            </Box>
          )}
        </Stack>
      </Box>
    </Card>
  );
};

export default RecentSupporterCard;
